module.exports = __webpack_public_path__ + "img/zacknite.9ecf0706.png";